import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-remove",
  "use": "icon-remove-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-remove\"><path d=\"M896 855.68V168.32a40.32 40.32 0 0 0-40.96-40.32H392.96c-23.04 0-41.6 17.92-41.6 40.32s17.92 40.32 41.6 40.32h419.84v606.72H392.96c-23.04 0-41.6 17.92-41.6 40.32s17.92 40.32 41.6 40.32h462.08c22.4 0 40.96-17.92 40.96-40.32z\" fill=\"#FF6625\" p-id=\"1697\" /><path d=\"M354.56 691.84c16.64-16 16-41.6 0-57.6L228.48 511.36l126.08-121.6c16.64-16 16.64-41.6 0.64-57.6A42.24 42.24 0 0 0 325.76 320c-10.88 0-21.76 4.48-29.44 11.52L140.16 482.56c-7.68 7.68-12.16 17.92-12.16 28.8 0 10.24 4.48 21.12 12.16 28.8l156.16 151.68c7.68 7.68 18.56 12.16 28.8 12.16 10.88 0 21.76-4.48 29.44-12.16z\" fill=\"#FF6625\" p-id=\"1698\" /><path d=\"M629.76 511.68c0-22.4-17.92-40.32-41.6-40.32H195.2c-23.04 0-41.6 17.92-41.6 40.32s17.92 40.32 41.6 40.32h392.96c23.68 0 41.6-17.92 41.6-40.32z\" fill=\"#FF6625\" p-id=\"1699\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/remove.svg
// module id = VFDz
// module chunks = 27